var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('custom-header',{attrs:{"actIndex":_vm.actIndex,"imgList":_vm.imgList,"topStyle":_vm.topStyle,"logo":_vm.logo,"titleObj":_vm.titleObj}}),_vm._v(" "),_c('custom-center'),_vm._v(" "),_c('custom-footer',{attrs:{"bottom":_vm.bottom,"bottomInfo":_vm.bottomInfo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2501a152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/Custom.vue
// module id = null
// module chunks = 